"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var applicationSegmentOneMarker = 0xFFE1;
var beginOfExifHeaderMarker = 0x45786966;
var byteOrderMarker = 0x4949;
var byteStuffingMarker = 0xFF00;
var orientationMarker = 0x0112;
var startOfFileMarker = 0xFFD8;
var parseBytes = function (dataView, resolve) {
    var offset = 2;
    while (offset < dataView.byteLength) {
        var marker = dataView.getUint16(offset, false);
        offset += 2;
        if (marker === applicationSegmentOneMarker
            && dataView.getUint32(offset + 2, false) !== beginOfExifHeaderMarker) {
            resolve(-1);
        }
        else if (marker === applicationSegmentOneMarker) {
            offset += 8;
            var little = dataView.getUint16(offset, false) === byteOrderMarker;
            offset += dataView.getUint32(offset + 4, little);
            var tags = dataView.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
                if (dataView.getUint16(offset + (i * 12), little) === orientationMarker) {
                    resolve(dataView.getUint16(offset + (i * 12) + 8, little));
                }
            }
        }
        else if ((marker & byteStuffingMarker) !== byteStuffingMarker) {
            resolve(-1);
        }
        else {
            offset += dataView.getUint16(offset, false);
        }
    }
    resolve(-1);
};
var determineOrientation = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                try {
                    var reader_1 = new FileReader();
                    reader_1.onload = function () {
                        var dataView = new DataView(reader_1.result);
                        if (dataView.getUint16(0, false) !== startOfFileMarker) {
                            resolve(-1);
                        }
                        parseBytes(dataView, resolve);
                    };
                    reader_1.readAsArrayBuffer(new Blob([file]).slice(0, 64 * 1024));
                }
                catch (error) {
                    resolve(1);
                }
            })];
    });
}); };
exports.default = {
    determineOrientation: determineOrientation,
};
